import { createContext } from "react";

const ContextoToken = createContext();

export default ContextoToken;
